import * as React from "react";

export const Network = () => {
  return <h1>Network</h1>;
};
